import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { Subject } from "rxjs";

import { CoolLocalStorage } from "@angular-cool/storage";
import { MDBModalRef } from "ng-uikit-pro-standard";

import { XrPlatformRestService } from "src/app/services/rest/xr-platform/xr-platform-rest.service";

import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { TitleCasePipe } from "@angular/common";
import { NotificationsService } from "src/app/services/utilities/notifications.service";

@Component({
  selector: "app-manage-app-device-types",
  templateUrl: "./manage-app-device-types.component.html",
  styleUrls: ["./manage-app-device-types.component.scss"],
  encapsulation: ViewEncapsulation.None,
  providers: [TitleCasePipe],
})
export class ManageAppDeviceTypesComponent {
  //incoming
  public teamID: number;
  public type: string;
  public targetDeviceType: any;
  public action: string;
  public data: any;

  private preSelected: {
    label: string;
    name: string;
    description: string;
  };

  public manageAppDeviceTypeForm: UntypedFormGroup;
  public formLoading: boolean = false;

  public formState: string = "active";
  public token: string;
  private outgoing: Subject<any> = new Subject();

  //icons
  public faTimes = faTimes;

  constructor(
    private _xrPlatformRestService: XrPlatformRestService,
    public appDeviceTypeFrame: MDBModalRef,
    private coolLocalStorage: CoolLocalStorage,
    private _notificationService: NotificationsService,
    private TitleCase: TitleCasePipe
  ) {}

  ngOnInit(): void {
    this.retrieveToken();
    this.buildPreselected();
    this.makeValidatingForm();
  }

  private retrieveToken() {
    this.token = this.coolLocalStorage.getItem("admin_panel_jwt");
  }

  private buildPreselected() {
    if (!this.targetDeviceType) {
      this.preSelected = {
        label: "",
        name: "",
        description: "",
      };
    } else {
      this.preSelected = {
        label: this.targetDeviceType.label,
        name: this.targetDeviceType.name,
        description: this.targetDeviceType.description,
      };
    }
  }

  private makeValidatingForm() {
    this.manageAppDeviceTypeForm = new UntypedFormGroup({
      label: new UntypedFormControl(
        this.preSelected.label,
        Validators.required
      ),
      name: new UntypedFormControl(this.preSelected.name, Validators.required),
      description: new UntypedFormControl(this.preSelected.description),
    });
  }

  //getters for form controls
  get label() {
    return this.manageAppDeviceTypeForm.controls.label;
  }

  get name() {
    return this.manageAppDeviceTypeForm.controls.name;
  }

  public manageAppDeviceType() {
    let actionAdj = this.action.replace(/e$/, "");
    let notification = this._notificationService.savingNotification(
      `${this.TitleCase.transform(actionAdj)}ing ${this.type}...`
    );

    let outbound = {
      label: this.manageAppDeviceTypeForm.value.label,
      name: this.manageAppDeviceTypeForm.value.name,
      description: this.manageAppDeviceTypeForm.value.description,
      archived: this.targetDeviceType ? this.targetDeviceType.archived : false,
    };

    if (this.action === "delete") outbound.archived = true;

    //determine the type of request
    let requestType = this.action === "edit" || this.action === "delete" ? "put" : "post";
    let requestURL =
      requestType === "put"
        ? `/app-device/${this.targetDeviceType.id}`
        : "/app-device";

    //user xrplatformrest service to make the request
    const headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + this.token,
    };

    const options = {
      headers: headers,
    };

    let manageVersion = this._xrPlatformRestService.restfulAPIQuery(
      requestURL,
      requestType,
      outbound,
      options
    );

    manageVersion.subscribe(
      (response: any) => {
        //clear notification
        this._notificationService.clearNotification(notification);

        this._notificationService.successNotification(
          `${this.TitleCase.transform(actionAdj)}ed ${this.type}!`
        );
        this.outgoing.next(response);
        this.appDeviceTypeFrame.hide();
      },
      (error: any) => {
        //clear notification
        this._notificationService.clearNotification(notification);

        this._notificationService.errorNotification(
          `Error while ${this.TitleCase.transform(actionAdj)}ing ${
            this.type
          }. Please try again or contact support`
        );
        this.outgoing.next(error);
        this.appDeviceTypeFrame.hide();
      }
    );
  }
}
